export const ZERO_OUT_BALANCES_SET_ERROR = 'ZERO_OUT_BALANCES_SET_ERROR';
export const ZERO_NEGATIVE_BALANCES_LOADING = 'ZERO_NEGATIVE_BALANCES_LOADING';
export const ZERO_NEGATIVE_BALANCES_SET_SAVE_SUCCESSFULL =
  'ZERO_NEGATIVE_BALANCES_SET_SAVE_SUCCESSFULL';
export const ZERO_NEGATIVE_BALANCE_CLEAR_ERROR =
  'ZERO_NEGATIVE_BALANCE_CLEAR_ERROR';
export const ZERO_OUT_NEGATIVE_BALANCES = 'ZERO_OUT_NEGATIVE_BALANCES';
export const ZERO_OUT_NEGATIVE_BALANCES_GET_NEGATIVE_BALANCES =
  'ZERO_OUT_NEGATIVE_BALANCES_GET_NEGATIVE_BALANCES';
export const ZERO_NEGATIVE_BALANCES_CHECK = 'ZERO_NEGATIVE_BALANCES_CHECK';
export const ZERO_NEGATIVE_BALANCES_CHECK_ALL =
  'ZERO_NEGATIVE_BALANCES_CHECK_ALL';
export const ZERO_NEGATIVE_BALANCES_SUBMIT = 'ZERO_NEGATIVE_BALANCES_SUBMIT';
export const ZERO_NEGATIVE_BALANCES_CLEAR_NEGATIVE_COUNT =
  'ZERO_NEGATIVE_BALANCES_CLEAR_NEGATIVE_COUNT';
export const ZERO_NEGATIVE_BALANCES_NO_DATA_DIALOG =
  'ZERO_NEGATIVE_BALANCES_CLEAR_NO_DATA_DIALOG';
export const ZERO_NEGATIVE_BALANCES_DIALOG =
  'ZERO_NEGATIVE_BALANCES_CLEAR_DIALOG';



// WEBPACK FOOTER //
// ./src/pages/utilities/state/zeroNegativeBalance/types.js